import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation-approval-form',
  templateUrl: './quotation-approval-form.component.html',
  styleUrls: ['./quotation-approval-form.component.css']
})
export class QuotationApprovalFormComponent implements OnInit {
  title="Quotation Approval";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component.ts